<template>
  <div>
    <TrustTypeList :canAdd="true" :canEdit="true" :canDelete="true" />
  </div>
</template>

<script>
// @ is an alias to /src
import TrustTypeList from '@/components/OD/TrustTypeList.vue';

export default {
  name: 'OfficialDepositoryTrustTypes',
  components: {
    TrustTypeList,
  },
};
</script>
